import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetGrammarNextPointV1Response } from './get-grammar-next-point-v1-response';
import { getGrammarNextPointV1ResponseSchema } from './get-grammar-next-point-v1-response';

export async function getGrammarNextPointV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetGrammarNextPointV1Response>> {
  return getRequest<IGetGrammarNextPointV1Response>({
    path: '/grammar/next-point/v1',
    schema: getGrammarNextPointV1ResponseSchema,
    options,
  });
}
